import React from 'react';
import { Link } from 'react-router-dom';
import Services from '../components/Services/Services';
import Products from '../components/Products/Products';
import Testimonials from '../components/Testimonials/Testimonials';
import { presentation, mission, whyWote } from '../data/siteContent';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import '../styles/waves.css';
import './Home.css';

/**
 * Page d'accueil - Hero section avec présentation de Wote
 * Inclut les sections Services, Nos Réalisations et Témoignages
 */
function Home() {
  // Les 6 premiers projets du portfolio
  const featuredProjects = [
    {
      id: 1,
      title: 'La Fabrique de Dieu',
      category: 'Application Web',
      description: 'Site web pour l\'Église avec système d\'adhésion et gestion des événements',
      technologies: ['Laravel', 'Blade', 'MySQL'],
      image: '/logo3.png',
      url: 'https://lafabriquededieu.com/'
    },
    {
      id: 2,
      title: 'AltCoach',
      category: 'Application Web',
      description: 'Plateforme de coaching professionnel avec gestion de sessions',
      technologies: ['Laravel', 'Inertia', 'React', 'MySQL'],
      image: '/logo3.png',
      url: 'https://altcoach.org/'
    },
    {
      id: 3,
      title: 'EbuFact',
      category: 'Application Web',
      description: 'Plateforme de facturation intelligente pour EBUTELO',
      technologies: ['React', 'Laravel', 'MySQL'],
      image: '/logo3.png',
      url: 'https://fact.ebuapp.com/'
    },
    {
      id: 4,
      title: 'EbuResto',
      category: 'Application Web',
      description: 'Plateforme de gestion de restaurant pour EBUTELO',
      technologies: ['React', 'Laravel', 'MySQL'],
      image: '/logo3.png',
      url: 'https://resto.ebuapp.com/'
    },
    {
      id: 5,
      title: 'ACADEX',
      category: 'Projet Académique - TFE',
      description: 'Plateforme de gestion académique universitaire avec paiement Mobile Money',
      technologies: ['Laravel', 'Blade', 'Flutter', 'MySQL'],
      image: '/logo3.png'
    },
    {
      id: 6,
      title: 'OMNI RFID',
      category: 'Projet Académique - TFE',
      description: 'Système de contrôle d\'accès intelligent par cartes RFID',
      technologies: ['Django', 'Python', 'MySQL', 'Arduino/ESP32'],
      image: '/logo3.png'
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-waves">
          <svg className="waves-left" viewBox="0 0 200 100" preserveAspectRatio="none">
            <path
              className="wave wave-red"
              d="M0,50 Q50,30 100,50 T200,50"
              vectorEffect="non-scaling-stroke"
            />
            <path
              className="wave wave-orange"
              d="M0,60 Q50,40 100,60 T200,60"
              vectorEffect="non-scaling-stroke"
            />
          </svg>
          <svg className="waves-right" viewBox="0 0 200 100" preserveAspectRatio="none">
            <path
              className="wave wave-blue"
              d="M0,50 Q50,30 100,50 T200,50"
              vectorEffect="non-scaling-stroke"
            />
            <path
              className="wave wave-purple"
              d="M0,60 Q50,40 100,60 T200,60"
              vectorEffect="non-scaling-stroke"
            />
          </svg>
        </div>

        <div className="container">
          <div className="hero-content">
            {/* Ordre DOM = ordre mobile : badge+titre, image, description+CTA */}
            <div className="hero-left-top">
              <span className="hero-badge">Au-dela de l'imagination</span>
              <h1 className="hero-title">
                Construisons les solutions digitales <span className="hero-title-accent">qui font grandir l'Afrique.</span>
              </h1>
            </div>
            <div className="hero-right">
              <div className="hero-visual-card">
                <img
                  src="/dev2.png"
                  alt="Developpeur travaillant sur plusieurs ecrans de code"
                  className="hero-visual-image"
                />
              </div>
            </div>
            <div className="hero-left-bottom">
              <p className="hero-description">
                {presentation.intro}
              </p>
              <div className="hero-actions">
                <a href="#services" className="hero-primary-btn">
                  Demarrer un projet
                </a>
                <div className="hero-whatsapp">
                  <WhatsAppButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Section Services */}
      <Services />

      {/* Section Nos Produits */}
      <Products showViewAll={false} />

      {/* Section Pourquoi nous */}
      <section className="why-us-section">
        <div className="container">
          <div className="why-us-grid">
            <span className="why-us-kicker">Pourquoi nous</span>
            <div className="why-us-preview">
              <img src="/why.png" alt="Apercu Wote" className="why-us-preview-image" />
            </div>
            
            <div className="why-us-content-body">
              <h2 className="why-us-title">Plus qu'un prestataire, un partenaire de croissance.</h2>
              <ul className="why-us-list">
                {whyWote.slice(0, 3).map((item) => (
                  <li key={item.title}>{item.text}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section Nos Réalisations */}
      <section className="projects-preview-section">
        <div className="container">
          <div className="projects-preview-header">
            <h2 className="section-title">Nos Réalisations</h2>
            <p className="section-subtitle">
              Découvrez quelques-uns de nos projets réalisés avec succès
            </p>
            <i className="section-subtitle">
              Cliquez sur un projet pour en savoir plus
            </i>
            
          </div>

          <div className="projects-preview-grid">
            {featuredProjects.map((project) => (
              <div key={project.id} className="project-preview-card">
                <div className="project-preview-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-preview-overlay">
                    <div className="project-tech">
                      {project.technologies.map((tech, index) => (
                        <span key={index} className="tech-badge">{tech}</span>
                      ))}
                    </div>
                    {project.url && (
                      <a 
                        href={project.url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="project-link-btn"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Voir le site
                      </a>
                    )}
                  </div>
                </div>
                <div className="project-preview-content">
                  <span className="project-category">{project.category}</span>
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="projects-preview-cta">
            <Link to="/portfolio" className="view-all-projects-btn">
              <span>Voir tous nos projets</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* Section Notre Mission */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <div className="mission-header">
                <h2 className="mission-title">Notre Mission</h2>
              </div>
              <div className="mission-body">
                <p className="mission-description">{mission.text}</p>
                <p className="mission-description">{mission.complement}</p>
                <p className="mission-tagline">
                  &quot;Au delà de l&apos;imagination!&quot; — la philosophie qui guide chaque projet WOTE.
                </p>
              </div>
            </div>
            <div className="mission-logo-card">
              <img src="/team.png" alt="Wote Logo" className="mission-logo-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Section Fondateur */}
      <section className="founder-section" id="fondateur">
        <div className="container">
          <div className="founder-content">
            <div className="founder-image-card">
              <img src="/moi.png" alt="Jonathan KONDE - Fondateur de Wote, Consultant Informatique et Entrepreneur à Kinshasa, RDC" className="founder-image" />
            </div>
            <div className="founder-text">
              <div className="founder-header">
                <h2 className="founder-title">Le Fondateur</h2>
                <h3 className="founder-name">Jonathan KONDE</h3>
              </div>
              <div className="founder-body">
                <p className="founder-description">
                  Passionné par la technologie et l'innovation, Jonathan KONDE est le fondateur de Wote,
                  une startup dédiée à l'accompagnement des étudiants et des entreprises dans leurs projets
                  technologiques et académiques.
                </p>
                <p className="founder-description">
                  Basé à Kinshasa en République Démocratique du Congo, il met son expertise au service
                  de la réussite académique et de l'excellence technologique. Avec une vision claire
                  et un engagement ferme, il guide Wote vers l'innovation et l'excellence.
                </p>
                <p className="founder-tagline">
                  "Au delà de l'imagination!" - C'est cette philosophie qui guide chaque projet Wote.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section CTA Final */}
      <section className="home-final-cta">
        <div className="container">
          <div className="home-final-cta-card">
            <h2 className="home-final-cta-title">Pret a donner vie a votre projet ?</h2>
            <p className="home-final-cta-text">
              Discutons de vos idees et construisons ensemble la prochaine solution qui fait la difference.
            </p>
            <div className="home-final-cta-actions">
              <WhatsAppButton />
              <a href="mailto:contact@wotes.org" className="home-email-btn">
                Envoyer un email
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Section Témoignages */}
      <Testimonials />
    </div>
  );
}

export default Home;

